import { useTranslations as intlUseTranslations } from 'next-intl';

export type TKey = Parameters<ReturnType<typeof useTranslations>>[0];

export const useTranslations = () => {
  // we need this wrapper to avoid using several useTranslations in one component
  return intlUseTranslations();
};
